module.exports = __webpack_public_path__ + "img/Multindo Auto Finance.d11db219.png";